export default __webpack_public_path__ + "static/media/icon_audio_pause.7e13c871.svg";